// extracted by mini-css-extract-plugin
export default {"radio_select":"styles_radio_select__AfZ37","label_text":"styles_label_text__7pn7q","option_image":"styles_option_image__NlA+8"};